import { render } from "./AmountLabel.vue?vue&type=template&id=80d920c8"
import script from "./AmountLabel.vue?vue&type=script&lang=js"
export * from "./AmountLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__